const navigateTo = (url: string) => window.location.assign(url);

export default navigateTo;
